import { render } from "./hamburger.vue?vue&type=template&id=16d96bbf&scoped=true"
import script from "./hamburger.vue?vue&type=script&lang=js"
export * from "./hamburger.vue?vue&type=script&lang=js"

import "./hamburger.vue?vue&type=style&index=0&id=16d96bbf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d96bbf"]])

export default __exports__